export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ENGLISH"] = "ENG";
    LanguageCode["FRENCH"] = "FRE";
    LanguageCode["SPANISH"] = "SPA";
})(LanguageCode || (LanguageCode = {}));
export var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["ENGLISH_US"] = "en-US";
    Language["FRENCH_CANADA"] = "fr-CA";
    Language["FRENCH_FRANCE"] = "fr-FR";
    Language["FRENCH"] = "fr";
    Language["INVARIANT"] = "";
    Language["SPANISH_SPAIN"] = "es-ES";
    Language["SPANISH"] = "es";
})(Language || (Language = {}));
//# sourceMappingURL=LanguageCode.js.map